/* ========================== */  
/* ========= import ========= */  
/* ========================== */

/* ====== React ====== */
import React from 'react';

/* ====== CSS ====== */
import styled from 'styled-components';

/* ====== Component Js/Jsx ====== */
import { dialogMessage } from '../../03CommonApiParts/MessageList';
import { assets } from '03CommonApiParts/Configuration';

/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */ 

/* ====== Styled Components ====== */
/* ------ダイアログコンテンツ ------*/
const SdivDialogGroup = styled.div`//ダイアログ枠
`;
const SdivOverlay = styled.div` //背景色
	position:fixed;
	top:0;
	left:0;
	width:100%;
	height:100%;
	background: rgba(0, 0, 0, 0.6);
    z-index:80;
`;
const Sdialog = styled.dialog` //ダイアログメッセージ
    background-color: white;
    padding: 12px;
    position:fixed;
    z-index:80;
    top: 20%;
    width: 490px;
	border-radius:3px;
    border: none;
    border: 2px solid #2E94B9;
`;
const SpTitle = styled.p`//ダイアログタイトル
    width: auto;
    line-height:16px;
    margin: 0px 0px 15px 0px;
    padding-bottom: 3px;
    font-weight: bold;
    color: #007BC3;
    border-bottom: 1px solid #2E94B9;
`;
const SdivContents = styled.div`//ダイアログ内容枠
    margin:5px 0;
    padding: 10px;
    margin-bottom: 10px;
`;
const SpContent = styled.p`//ダイアログ内容
    margin:0px;
    line-height:16px;
`;

/* ------ボタン ------*/
const SbuttonOK = styled.button`//OKボタン
    white-space:nowrap;
    display:flex;
    align-items:center;
    justify-content:center;
    background-color: white;
    border: solid 1.5px #2E94B9;
    border-radius: 3px;
    color: #007BC3;
    font-weight:bold;
    height: 28px;
    position: relative;
    width:81px;
    margin: 0 0 0 10px;
    &:hover{
        background-color: #EEEEEE;
        cursor: pointer;
    }
    &:active{
        top:1px;
        left:1px;
        box-shadow: none;
        background-color:#2E94B9;
        color:white;
    }
`;
const SbuttonCancel = styled(SbuttonOK)`//キャンセルボタン
    color: #7F7F7F;
    border-color: #7F7F7F;
    margin: 0 0 0 10px;
    &:active{
        background-color:#7F7F7F;
        color:white;
    }
`;
const SdivButtonGroup = styled.div`//ボタン枠
    display:flex;
    justify-content:flex-end;
    width:100%;
	line-height: 28px;
    margin-top: 10px;
`;

/*==================*/
/*=====  Main  =====*/
/*==================*/
export const Dialog = (props) => {

    /* ========================== */  
    /* ========== variables ========== */  
    /* ========================== */    
    const { content, set, onClickDiscard, onClickSave } = props;
    
    /*------ モーダル表示時はフォーカスを外す ------*/
    if(content.open){
        var obj = document.activeElement;
        if (obj) {
          obj.blur();
        }
    }
    
    /*------キャンセルボタン押下処理 ------*/
    const onClose = () => { //ダイアログを閉じる
        set({
            ...content,
            open: false,
        })
    };

    /*------ OKボタン押下処理------*/
    const onClickOkButton = () => {
        content.afterFunc();
        set({
            ...content,
            open: false,
            pattern:null,
            level:null,
            type:null,
            content:null,
        })
    }

    /*------ 一時保存ボタン押下処理------*/
    const onClickSaveButton = () => {
        set({
            ...content,
            open: false,
            pattern:null,
            level:null,
            type:null,
            content:null,
        });
        //type:一時保存ボタン押下後にどの処理を走らせるかを識別
        //data :一時保存ボタン押下後に処理するデータ
        onClickSave(); 
    }

    /*------ 一時保存破棄ボタン押下処理------*/
    const onClickDiscardButton = () => {
        set({
            ...content,
            open: false,
        })
        onClickDiscard(); 
    }

    /*------ ダイアログのタイトル表示 ------*/   
    const dialogTitle = (contents) => {
        let title;
        let level;
        if(contents.type === 'text'){
            level = 'E';
        }else{
            level = contents.message.slice(3,4);
        };
        switch(level){
            case 'C':
                title = '確認';
                break;
            case 'I':
                title = 'お知らせ';
                break;
            case 'E':
                title = 'エラー';
                break;
            case 'W':
                title = '注意!';
                break;
            default:
                title = 'データがありません。';
                break;
        };
        return title;
        
    };

    /*------ ダイアログのメッセージ表示 ------*/
    const dialogContents = (contents) => {
        let message;
        if(contents.type === 'text'){
            message = contents.message;
        }else{
            message = dialogMessage(contents.message,contents.$1,contents.$2,contents.$3,contents.$4,contents.$5,contents.$6,contents.$7);
        }

        return message
    };

    /* ========================== */  
    /* ====== Start Render ====== */  
    /* ========================== */

    return (
        <>
            {content.open ?
                <SdivDialogGroup>
                    <SdivOverlay />
                    <Sdialog open>
                        <SpTitle className='titleText' style={{fontSize:assets().size.titleText}}>{dialogTitle(content)}</SpTitle>
                        <SdivContents className='baseText' style={{fontSize:assets().size.baseText}}>
                            {dialogContents(content).split('\n').map((str, index) => (
                                index === 4 ?
                                <SpContent key={index}>{str}...</SpContent>
                                :index > 4 ?
                                ''
                                :<SpContent key={index}>{str}<br /></SpContent>
                            ))}
                        </SdivContents>
                            {/* パターン4：破棄ボタン・継続ボタンを表示 */}
                            {content.pattern === 4 ? 
                            <>
                                {/* <SdivBorder/>
                                <SdivPush/> */}
                                <SdivButtonGroup >
                                    <SbuttonCancel className='dialogButtonStyle' style={{height:assets().size.dialogButtonHeight,width:assets().size.dialogButtonWidth,fontSize:assets().size.baseText}} onClick={onClickDiscardButton}>破棄</SbuttonCancel>
                                    <SbuttonOK className='dialogButtonStyle' style={{height:assets().size.dialogButtonHeight,width:assets().size.dialogButtonWidth,fontSize:assets().size.baseText}} onClick={onClickOkButton}>継続</SbuttonOK>
                                </SdivButtonGroup>
                            </>
                            :<div></div>}
                            {/* パターン3：一時保存ボタン・キャンセル・OKボタンを表示 */}
                            {content.pattern === 3 ? 
                                <SdivButtonGroup>
                                    <SbuttonOK className='dialogButtonStyle' style={{height:assets().size.dialogButtonHeight,width:assets().size.dialogButtonWidth,fontSize:assets().size.baseText}} onClick={onClickSaveButton}>一時保存</SbuttonOK>
                                    <SbuttonCancel className='dialogButtonStyle' style={{height:assets().size.dialogButtonHeight,width:assets().size.dialogButtonWidth,fontSize:assets().size.baseText}} onClick={onClose}>キャンセル</SbuttonCancel>
                                    <SbuttonOK className='dialogButtonStyle' style={{height:assets().size.dialogButtonHeight,width:assets().size.dialogButtonWidth,fontSize:assets().size.baseText}} onClick={onClickOkButton}>OK</SbuttonOK> 
                                </SdivButtonGroup>
                            :<div></div>}
                            {/* パターン2：キャンセル・OKボタンのみ表示 */}
                            {content.pattern === 2 ? 
                                <SdivButtonGroup >
                                    <SbuttonCancel className='dialogButtonStyle' style={{height:assets().size.dialogButtonHeight,width:assets().size.dialogButtonWidth,fontSize:assets().size.baseText}} onClick={onClose}>キャンセル</SbuttonCancel>
                                    <SbuttonOK className='dialogButtonStyle' style={{height:assets().size.dialogButtonHeight,width:assets().size.dialogButtonWidth,fontSize:assets().size.baseText}} onClick={onClickOkButton}>OK</SbuttonOK> 
                                </SdivButtonGroup>
                            :<div></div>}
                            {/* パターン1：OKボタンのみ表示 */}
                            {content.pattern === 1 ?
                                <SdivButtonGroup>
                                    <SbuttonOK className='dialogButtonStyle' style={{height:assets().size.dialogButtonHeight,width:assets().size.dialogButtonWidth,fontSize:assets().size.baseText}} onClick={onClickOkButton}>OK</SbuttonOK> 
                                </SdivButtonGroup>
                            :<div></div>
                            }
                    </Sdialog>
                </SdivDialogGroup>
            : ''}            
        </>
    )
};



// 使い方
// const [dialogMessage, setDialogMessage] = useState({ //ダイアログ表示用
//     open:false,
// })
// // /*------ ダイアログのOKボタンを押した時の処理　------*/
// const onClickDialogOK = async(type,row) =>{  //type(押下したボタンの種類),row(データ)
//     /*------ セッション切れ確認 ------*/
//     checkSession(history);
//     /*------ 受け取ったvalueを元に対象の処理を判別 ------*/
//     if(type === 'update'){         
//         updateFunc(row);                //updateなら更新の処理
//     }else if(type === 'delete'){
//         deleteFunc();                   //deleteなら削除の処理
//     }
// }
//    /*------ 更新ボタンを押した時の処理 ------*/
//    const executeRegist = (row) => {
        //更新確認ダイアログを表示
    //     setDialogMessage({      
    //         ...dialogMessage,
    //         open: true,
    //         message: 'IDHC001',//更新確認ダイアログ
    //         type: 'update', //更新API処理
    //         data: row,//更新データ
    //     }););
    // };
//  <Dialog
// content={dialogMessage}
// set={setDialogMessage}
// onClick={onClickDialogOK}
// /> 